import type { ReactNode } from 'react'
import type { LearnerProfileData } from '~/gql/users/learner-profile'
import { useTranslation } from 'react-i18next'
import { useBranding } from '~/helpers/branding/branding-context'
import { DATE_WITH_YEAR, formatSessionDate } from '~/helpers/dates/session-dates'
import ProfileSection from './ProfileSection'

type ProfileInfoProps = {
  profile: Pick<LearnerProfileData, 'firstName' | 'lastName' | 'email' | 'username' | 'company' | 'department' | 'createdAt'>
  /** « Modifier », pour qui en a le droit : la modale existante, pas d'édition ici. */
  action?: ReactNode
}

/** Les informations du compte, en lecture (#242). */
function ProfileInfo({ profile, action }: ProfileInfoProps) {
  const { t, i18n } = useTranslation()
  const { timezone } = useBranding()

  const rows = [
    { label: t('common.firstname'), value: profile.firstName },
    { label: t('common.lastname'), value: profile.lastName },
    { label: t('common.email'), value: profile.email },
    ...(profile.username ? [{ label: t('common.username'), value: profile.username }] : []),
    { label: t('user.company'), value: profile.company },
    { label: t('user.department'), value: profile.department },
    { label: t('profile.info.createdAt'), value: formatSessionDate(profile.createdAt, i18n.language, timezone, DATE_WITH_YEAR) },
  ]

  return (
    <ProfileSection title={t('profile.info.title')} anchor="profile.info" action={action}>
      <dl className="grid gap-3 text-sm sm:grid-cols-[auto_1fr]">
        {rows.map(row => (
          <div key={row.label} className="contents">
            <dt className="text-muted-foreground">{row.label}</dt>
            <dd className="break-all font-medium">{row.value || '—'}</dd>
          </div>
        ))}
      </dl>
    </ProfileSection>
  )
}

export default ProfileInfo
